/*
 * Makes HTTP calls to the Invites API.
 * Used by Accounts and Web V2 to respond to an invite.
 *
 */
import { useApi } from './useApi';

const INVITES_API_ERROR_CODE = 'invites-api';

export function useInvitesApi() {
    const { callApi, ApiMethod } = useApi();

    async function callValidateInviteApi(inviteUid) {
        return await callInvitesApi(null, inviteUid, ApiMethod.GET);
    }

    async function callResendInviteApi(email, inviteUid) {
        return await callInvitesApi(null, inviteUid, ApiMethod.POST, { email });
    }

    async function callAcceptInviteApi(inviteUid, user) {
        return await callInvitesApi(user, inviteUid, ApiMethod.PUT, { accepted: true });
    }

    async function callDeclineInviteApi(inviteUid, user) {
        return await callInvitesApi(user, inviteUid, ApiMethod.PUT, { accepted: false });
    }

    async function callInvitesApi(user, inviteUid, method, bodyParams) {
        try {
            return await callApi(user, method, `/requests-api/invites/${inviteUid}`, bodyParams);
        } catch (error) {
            const message = error.statusText || (error.status === 404 ? `Invite ${inviteUid} not found` : '');
            const inviteError = new Error(message, { cause: error.status });
            inviteError.code = error.code || INVITES_API_ERROR_CODE; // Error options only support 'cause', so set the code explicitly
            throw inviteError;
        }
    }

    return {
        callValidateInviteApi,
        callResendInviteApi,
        callAcceptInviteApi,
        callDeclineInviteApi,
    };
}
